import './App.scss';
import { Game } from './components/Game';

const App: React.FC = () => {
  return (
      <Game />
  );
}

export default App;
